import type { FaireProductEntity } from "../../entity_types/product";

export const p_pqf2f49nzz: FaireProductEntity = {
  token: "p_pqf2f49nzz",
  type: "product",
  name: "Novaé 18K Gold Non-Tarnish CZ Mix Earring Set",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/00f74157224de0a599174cd67cfe45d235b4fb2286567b49ae4eb1bfb1508653.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a54b1e5a916e4aaa152b2ed9cb6c4b4b2b2fb9fd1ebcced2bd029ff3e1b5094.jpeg",
    "https://cdn.faire.com/fastly/a19a3ec44660660992cacdef479c93043c7b44bd0c5e518d869430d1770cdcb4.jpeg",
    "https://cdn.faire.com/fastly/d05b6db388cd912aa2552bf95cf9c1ab0380653b9e1769b357108fd23f1bb66b.jpeg",
  ],
  priceDollars: 11.1,
  description:
    "18K Gold Non-Tarnish CZ Mix Earring Set\n18K Gold Plating\nStainless Steel \nCubic Zirconia\nMeasurement:\nRound Stud -0.38\nChain Stud - 0.76\nStar CZ- 0.21\n\n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:45.783Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
